import React from "react";
import SubPageLayout from "../components/SubPageLayout";
import AboutBlock from "../components/home/AboutBlock";
import Approach from "../components/home/Approach";
import FinalCta from "../components/home/FinalCta";

export default function AboutPage() {
  return (
    <SubPageLayout testid="about-page" eyebrow="About Us" title="Real People Behind Better Water."
      subtitle="A locally owned Northern Virginia company that tests first, explains clearly and recommends honestly."
      metaDescription="Meet Max and the family behind Honest Water LLC, a locally owned water treatment company in Northern Virginia.">
      <AboutBlock hideMore />
      <Approach id="process" />
      <FinalCta />
    </SubPageLayout>
  );
}
